import { render, staticRenderFns } from "./address.vue?vue&type=template&id=1d2dfdfa&scoped=true&lang=pug&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"
import style0 from "./address.vue?vue&type=style&index=0&id=1d2dfdfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2dfdfa",
  null
  
)

/* custom blocks */
import block0 from "./address.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsFormsButton: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/widgets/forms/button.vue').default,WidgetsFormsInput: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/widgets/forms/input.vue').default})
